import { inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type {
  MaterialUsesActiveFilter,
  MaterialUsesChannelFilter,
} from "@/lib/manufacturing/filterManufacturingMaterialUses";

type Props = {
  search: string;
  onSearchChange: (next: string) => void;
  activeFilter: MaterialUsesActiveFilter;
  onActiveFilterChange: (next: MaterialUsesActiveFilter) => void;
  channelFilter: MaterialUsesChannelFilter;
  onChannelFilterChange: (next: MaterialUsesChannelFilter) => void;
  channels: readonly string[];
};

export function ManufacturingMaterialUsesListToolbar(props: Props) {
  return (
    <div className="mb-3 space-y-2 border-b border-gray-100 pb-3 dark:border-zinc-700">
      <input
        className={inputClass}
        value={props.search}
        onChange={(e) => props.onSearchChange(e.target.value)}
        placeholder="Search name, code, notes, channel, materials — commas AND…"
        autoComplete="off"
      />
      <div className="flex flex-wrap items-center gap-2">
        <select
          className={`${inputClass} min-w-[9rem] flex-1`}
          value={props.activeFilter}
          onChange={(e) => props.onActiveFilterChange(e.target.value as MaterialUsesActiveFilter)}
          aria-label="Active filter"
        >
          <option value="active">Active only</option>
          <option value="inactive">Inactive only</option>
          <option value="all">All uses</option>
        </select>
        <select
          className={`${inputClass} min-w-[9rem] flex-1`}
          value={props.channelFilter}
          onChange={(e) =>
            props.onChannelFilterChange(e.target.value as MaterialUsesChannelFilter)
          }
          aria-label="Channel filter"
        >
          <option value="all">All channels</option>
          <option value="none">No channel (substitute)</option>
          {props.channels.map((ch) => (
            <option key={ch} value={ch}>
              Channel: {ch}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
